const Asterisk = () => <span>*</span>;

export default Asterisk;
